import './ModPanel.css';

export default function ModPanel({ pending, onApprove, onReject, onClose }) {
  return (
    <div className="modpanel-overlay" onClick={onClose}>
      <div className="modpanel card" onClick={e => e.stopPropagation()}>
        <div className="modpanel-header">
          <div>
            <h3>🛡️ Story Moderation</h3>
            <p>Only Emmi can see this! Review stories before they go live.</p>
          </div>
          <button className="modpanel-close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        {pending.length === 0 ? (
          <div className="modpanel-empty">
            <span>🎉</span>
            <strong>All caught up!</strong>
            <p>No stories waiting for review right now.</p>
          </div>
        ) : (
          <div className="modpanel-list">
            <div className="modpanel-count">
              {pending.length} {pending.length === 1 ? 'story' : 'stories'} waiting for review
            </div>
            {pending.map(post => (
              <div key={post.id} className="modpanel-item">
                <div className="moditem-meta">
                  <div className="moditem-avatar">{post.name.charAt(0).toUpperCase()}</div>
                  <div>
                    <strong>{post.name}</strong>
                    {post.city || post.country
                      ? <span className="moditem-location"> · {post.city ? `${post.city}, ` : ''}{post.country}</span>
                      : null}
                    <div className="moditem-category">{post.category}</div>
                  </div>
                  <div className="moditem-date">{post.date}</div>
                </div>
                <p className="moditem-message">"{post.message}"</p>
                <div className="moditem-actions">
                  <button className="btn btn-secondary mod-approve" onClick={() => onApprove(post.id)}>
                    ✅ Approve
                  </button>
                  <button className="btn mod-reject" onClick={() => onReject(post.id)}>
                    ❌ Remove
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
